/* Start: For access the laravel languages files in vue */
Vue.prototype.trans = (key, args) => {
  if (_.has(theme_settings, key)) {
    let value = _.get(window.theme_settings, key, key);
    return value;
  } else {
    let value = _.get(window.trans, key, key);

    _.eachRight(args, (paramVal, paramKey) => {
      value = _.replace(value, `:${paramKey}`, paramVal);
    });
  }
  return value;
};
/* End: For access the laravel languages files in vue */

Vue.prototype.route = (name, args) => {
  if (_.has(routes, name)) {
    let value = _.get(routes, name, name);
    let have_query_string = false;
    _.forEach(args, (paramVal, paramKey) => {
      if (paramKey !== "query") {
        value = _.replace(value, `{${paramKey}}`, paramVal);
      } else {
        have_query_string = true;
      }
    });

    if (value.charAt(0) !== "/") {
      value = "/" + value;
    }

    if (have_query_string) {
      let query = args["query"];
      if (query.charAt(0) !== "?") {
        query = "?" + query;
      }
      value += query;
    }

    return value;
  }
  return "";
};

/* Start: notification alert for success/error message from axios call */
Vue.prototype.notify = (type, message, link) => {
  opts["title"] = `<span class='flex justify-content-between'><span class='notification-message'>${message}</span>`;
  if (link && typeof link !== "undefined") {
    opts["title"] += `<span class='ntf-link'>${message_link}</span>`;
  }
  opts["title"] += `</span>`;

  if (type == "success") {
    PNotify.alert(opts);
  }
  if (type == "error") {
    PNotify.error(opts);
  }
};
/* End: notification alert for success/error message from axios call */

// var draggable = require('vuedraggable');

import Form from "./core/Form";
import Notification from "./components/Notification.vue";
import Feartured from "./components/Featured.vue";
import PopularClip from "./components/PopularClip.vue";
import ClipSlider from "./components/ClipSlider.vue";
import VueCarousel from "vue-carousel";
import Vuex from "vuex";

// import infiniteScroll from 'vue-infinite-scroll'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(VueCarousel);

Vue.component("book-clip-insert-section", require("./components/BookInsertClipSection.vue").default);
Vue.component("combine-book-clip-thumbnail", require("./components/CombineBookClipThumbnails.vue").default);
Vue.component("featured-book", require("./components/Featured.vue").default);
Vue.component("popular-clip", require("./components/PopularClip.vue").default);
Vue.component("popular-clip-pm", require("./components/PopularClipPm.vue").default);
Vue.component("save-book", require("./components/saveBook.vue").default);
Vue.component("save-view-book", require("./components/saveViewBook.vue").default);
Vue.component("save-clip", require("./components/saveClip.vue").default);
Vue.component("save-view-clip", require("./components/saveViewClip.vue").default);
Vue.component("clip-insert", require("./components/ClipInsert.vue").default);
Vue.component("add-clip-to-book-modal", require("./components/SaveClipInBook.vue").default);
Vue.component("chosen-select", require("./components/ChosenSelect.vue").default);
Vue.component("book-table-of-content-section", require("./components/BookTableOfContentSection.vue").default);
// Vue.component('clip-slider', require('./components/ClipSlider.vue').default);

Vue.component("partner-popular-clip", require("./components/PartnerPopularClip.vue").default);
Vue.component("partner-featured-book", require("./components/PartnerFeaturedBook.vue").default);
Vue.component("clip-list", require("./components/ClipList.vue").default);

window.Form = Form;

var obos = new Vue({
  el: "#obos",
  data: {
    modalStatus: false,
    clipId: "",
    clipName: "",
    sectionID: "",
    sectionName: "",
  },
  mounted: function () {
    // console.log(this.route("user.book.show"));
    // console.log(this.baseUrl());
  },
  methods: {
    showClipToBookModal(status, id, name = "", section_id, section_name) {
      this.modalStatus = status;
      if (id) {
        this.clipId = id;
      } else {
        this.clipId = "";
      }
      if (name) {
        this.clipName = name;
      } else {
        this.clipName = "";
      }
      if (section_id) {
        this.sectionID = section_id;
      } else {
        this.sectionID = "";
      }
      if (section_name) {
        this.sectionName = section_name;
      } else {
        this.sectionName = "";
      }
    },
  },
});

jQuery(document).ready(function ($) {
  var elementExists = document.getElementById("clipListAndInsertSection");

  if (typeof elementExists != "undefined" && elementExists != null) {
    require("./vue-book");
  }
});
